import { registerPlugin } from '@capacitor/core';
const CapacitorWechat = registerPlugin('CapacitorWechat', {
    web: () => import('./web').then((m) => new m.CapacitorWechatWeb()),
});
export * from './definitions';
export { CapacitorWechat };
//# sourceMappingURL=index.js.map